module.exports = __webpack_public_path__ + "static/media/WORKING_CAT.d34e543c.svg";